import { render, staticRenderFns } from "./InfoModal.vue?vue&type=template&id=5aac2e34&scoped=true&"
import script from "./InfoModal.vue?vue&type=script&lang=js&"
export * from "./InfoModal.vue?vue&type=script&lang=js&"
import style0 from "./InfoModal.vue?vue&type=style&index=0&id=5aac2e34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aac2e34",
  null
  
)

export default component.exports